import React from 'react';
import PropTypes from 'prop-types';
import classname from 'classnames';

import './CollapseWidget.scss';

const iconsMap = {
  open: {
    left: '#icon-triangle-left',
    right: '#icon-triangle-right',
  },
  close: {
    left: '#icon-triangle-right',
    right: '#icon-triangle-left',
  },
};


function OpenIndicator (props) {
  const { state, type } = props;

  return (
    <>
      <svg className={classname(
        'collapse-widget-icon',
        `collapse-widget-icon-${state}-${type}`,
        )}>
        <use xlinkHref={iconsMap[state]?.[type]}/>
      </svg>
    </>
  );
}

function Rectangle (props) {
  const { type, state } = props;

  return (
    <div className={classname(
      'collapse-widget-rectangle',
      `collapse-widget-rectangle-${state}-${type}`,
      `collapse-widget-rectangle-${state}`,
    )} />
  );
}

export default function CollapseWidget (props) {
  const {
    open,
    type,
    onClick,
    className,
  } = props;
  const state = open ? 'open' : 'close';

  return (
    <div
      onClick={onClick}
      className={classname(
        className,
        'collapse-widget',
        `collapse-widget-${state}-${type}`,
        `collapse-widget-${state}`,
        `collapse-widget-${type}`
      )}
      role='button'
    >
      <div className={classname(
        'collapse-widget-wrapper',
        `collapse-widget-wrapper-${state}-${type}`,
        `collapse-widget-wrapper-${state}`,
        `collapse-widget-wrapper-${type}`
      )}>
        <Rectangle
          state={state}
          type={type}
        />
        <OpenIndicator
          state={state}
          type={type}
        />
      </div>
    </div>
  );
}

CollapseWidget.defaultProps = {
  type: 'left',
};

CollapseWidget.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
